<template>
  <b-modal size="lg" ref="modal" hide-header hide-footer>
    <div class="container-fluid p-5">
      <div class="row text-center">
        <div class="col-md-3 m-auto">
          <div class="responsive-aspect-ratio square-aspect-ratio">
            <img :src="cover">
          </div>
        </div>
        <div class="col-12">
          <p class="p py-2 mb-0">Stai aggiungendo nella tua wishlist</p>
          <p class="h4 mb-0">{{ bookTitle }}</p>
          <p class="h5 font-weight-normal mb-0" id="edit-authors">{{ formattedAuthors }}</p>
        </div>
      </div>
      <form @submit.prevent="submitForm">
        <div class="row py-4">
          <div class="col-12">
            <p class="col-12 h4 text-center">Che edizione stai cercando?</p>
            <div class="row pb-4">
              <div class="col-12">
                <div class="d-flex justify-content-between">
                  <button
                    @click="allVersions = true"
                    class="btn btn-outline-dark text-uppercase"
                    :class="{
                    'active': allVersions,
                  }"
                    type="button"
                    id="btn-all-versions">
                    <i
                      :class="{
                      'far': !allVersions,
                      'fas': allVersions,
                      'fa-circle': !allVersions,
                      'fa-check-circle': allVersions,
                    }"
                    ></i>
                    Qualsiasi edizione
                  </button>
                  <button
                    @click="allVersions = false"
                    class="btn btn-outline-senary text-uppercase"
                    :class="{
                    'active': !allVersions
                  }"
                    type="button"
                    id="btn-this-version">
                    <i
                      :class="{
                      'far': allVersions,
                      'fas': !allVersions,
                      'fa-circle': allVersions,
                      'fa-check-circle': !allVersions,
                    }"
                    ></i>
                    Questa edizione
                  </button>
                </div>
              </div>
            </div>
            <div class="text-center" v-if="subscribed">
              <div class="notification_area">
                <input type="hidden" class="is_notifiable" name="notification" value="true">
                <button
                  @click="notificationsEnabled = !notificationsEnabled"
                  type="button"
                  class="btn btn-secondary text-white btn-notify-pro px-4"
                  :class="{
                  'active': notificationsEnabled,
                }"
                  style="width: auto;">
                  NOTIFICHE
                  <i
                    class="far ml-2 fs-15"
                    :class="{
                    'fa-bell': notificationsEnabled,
                    'fa-bell-slash': !notificationsEnabled,
                  }"
                  ></i>
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="form-row">
                  <div class="form-group col-12 d-flex justify-content-end">
                    <button @click="$refs.modal.hide()" type="button"
                            class="btn btn-link text-uppercase font-weight-bold" data-dismiss="modal"
                            aria-label="Close">Annulla
                    </button>
                    <button type="submit" class="btn btn-secondary text-white text-uppercase">Salva</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </b-modal>
</template>

<script>
import AddBookIntoWishlist from '../../../graphql/AddBookIntoWishlist.graphql';
export default {
  name: "WishlistModal",
  data() {
    return {
      allVersions: true,
      notificationsEnabled: this.$props.subscribed,
    }
  },
  props: {
    cover: String,
    bookVersionId: Number,
    bookTitle: String,
    authors: Array,
    subscribed: Boolean,
  },
  computed: {
    formattedAuthors() {
      return this.$props.authors
        .map((item) => item.name)
        .join(', ')
    }
  },
  methods: {
    open() {
      this.$refs.modal.show();
    },
    submitForm() {
      this.$apollo.mutate({
        mutation: AddBookIntoWishlist,
        variables: {
          book_version_id: this.bookVersionId,
          all_versions: this.allVersions,
          notifications_enabled: this.notificationsEnabled,
        }
      }).then((data) => {
        this.$refs.modal.hide();
        this.$bvToast.toast(`Libro aggiunto in wishlist`, {
          title: 'Wishlist',
          variant: 'success',
          autoHideDelay: 3000,
          appendToast: true,
        })
      }).catch((error) => {
        this.$bvToast.toast(`Errore durante l'aggiunta in wishlist, riprova più tardi`, {
          title: 'Wishlist',
          variant: 'danger',
          autoHideDelay: 3000,
          appendToast: true,
        })
      })
    }
  }
}
</script>

<style scoped>

</style>
